import React from 'react';
import PartnerLogo from '../../b2b/components/partner-logo/partner-logo';

interface HeaderBarProps {
  /** Right-aligned header actions (user menu, logout, ...) */
  children?: React.ReactNode;
  /** Forwarded to PartnerLogo (hides the discount/loyalty logo when false) */
  secondaryLogo?: boolean;
  className?: string;
}

/*
 * Top navigation bar (Figma: top-navigation/mobile, top-navigation/desktop).
 * Mobile-first with the project breakpoints (src/styles/breakpoints.ts):
 *   base (< 640px)  56px high incl. 1px neutral-300 divider, 16px side padding
 *   md   (>= 640px) 71px high, logo 44px from the left, actions 64px from the right
 *
 * Partners can re-theme the bar through `--header-background` in their
 * public/theme/<partner>/theme.css.
 *
 * The legacy `.logo` rule (unlayered, fixed 40px height + top margin) and the
 * inline `float:left` on PartnerLogo are overridden with the important modifier.
 */
const logoClass =
  'header-logo float-none! m-0! h-auto! max-h-[42px] w-[168px]! max-w-[50vw] object-contain object-left';

const HeaderBar: React.FC<HeaderBarProps> = ({
  children,
  secondaryLogo,
  className = '',
}) => (
  <header
    className={`relative z-20 flex h-14 items-center justify-between gap-4 border-b border-(--vel-color-neutral-300,#ddd) bg-(--header-background,var(--vel-color-neutral-white,#fff)) px-4 shadow-[0_4px_8px_0_rgba(9,30,66,0.08),0_0_1px_0_rgba(9,30,66,0.2)] md:h-[71px] md:border-b-0 md:pr-16 md:pl-11 ${className}`.trim()}
    data-testid='header'
  >
    <PartnerLogo
      data-testid='header-logo'
      className={logoClass}
      secondaryLogo={secondaryLogo}
    />
    {children && (
      <div
        className='flex items-center justify-end gap-1 md:gap-3'
        data-testid='header-actions'
      >
        {children}
      </div>
    )}
  </header>
);

export default HeaderBar;
